module.exports = __webpack_public_path__ + "img/beneficiaires.c6bd5c53.svg";